import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextInputField from "../../../components/forms/TextInputField";
import FormError from "../../../components/forms/FormError";

// Small confirmation form reused by the Dispatch / Cancel / Remove-pallet actions.
// Pass `withReason` to add a required reason field, and `submitLabel` for the button.
class TransferActionForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting, withReason, submitLabel} = this.props;
    let label = submitting ? "Standby..." : (submitLabel || "Submit");
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <p>{this.props.message}</p>
          {withReason &&
            <FormFieldsTable>
              <Field
                label="Reason"
                name="reason"
                component={TextInputField}
                serverError={this.props.errors.reason}
                />
            </FormFieldsTable>}
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={label} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "StockTransferActionForm"
})(TransferActionForm);

export default ReduxForm;
